<template>
  <div class="core">
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="allForm" :showForm="true" :rule="form_rulesp" requestUniqueId="backorderAudit" :after-save="handleAfterSave">
              <div class="layui-form">
                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单信息' : '服务请求工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <workOrder ref='workOrder' :editRow="formData"></workOrder>
                    </layui-collapse>
                  </template>
                </pub-collapse>

                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单信息' : '现场服务工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <serviceOrder ref='serviceOrder' :editRow="formData"></serviceOrder>
                      <signinout ref='signinout' :editRow="formData"></signinout>
                      <selfCheck ref='selfCheck' :editRow="formData"></selfCheck>
                      <acceptance ref='acceptance' :editRow="formData"></acceptance>
                      <backorder ref='backorder' :enabled="operateType == 'sp'" :editRow="formData"></backorder>
                    </layui-collapse>
                  </template>
                </pub-collapse>
              </div>
              <div class="layui-form-btn">
                <div class="layui-footer">
                  <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">关 闭</button>
                  <button class="layui-btn" title="保存" @click="handleBtnclick('save')" v-if="operateType == 'sp'">保 存</button>
                </div>
              </div>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrder from '../detailForm/workOrderForm'
import serviceOrder from '../detailForm/serviceOrderForm'
import signinout from '../detailForm/signInOutForm'
import selfCheck from '../detailForm/selfCheckForm'
import acceptance from '../detailForm/acceptanceForm'
import backorder from '../detailForm/backOrderForm'

export default {
  components: {
    workOrder,
    serviceOrder,
    backorder,
    signinout,
    selfCheck,
    acceptance
  },
  props: {
  },
  data () {
    return {
      form_rulesp: {
        REVIEW_TYPE: {
          required: { message: '审核结果不能为空'},
        },
        REVIEW_USERID: {
          required: { message: '审核人员不能为空'},
        }
      },
      formData: {},
      operateType: '',
      scrollTop: 0
    }
  },
  activated(){
    if(this.scrollTop) {
      $(".core").animate({scrollTop: this.scrollTop}, 0)
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.formData;
      this.operateType = this.tabParam.operateType;
      this.tableObj = this.tabParam.tableObj;
      if(this.operateType == 'sp') {
        let user = this.security.getUser();
        this.formData.REVIEW_USERID = user.getUname();
        this.formData.REVIEW_OPTION = ''; //清空审批意见
      }
    }
    this.$nextTick(()=> {
      var anchor = this.$refs.backorder.$el.offsetTop;
      $(".core").animate({
        scrollTop: anchor
      },500);
    });

    var that = this;
    $(".core").scroll(function(event){
      that.scrollTop = $(".core").scrollTop();
    })
  },
  methods: {
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu);
          this.baseComponent.loadComponentByName('backOrder');
          break
        }
        case 'save': {
          let date = new Date();//当前时间
          let year = date.getFullYear() //返回指定日期的年份
          let month = this.repair(date.getMonth() + 1);//月
          let day = this.repair(date.getDate());//日
          let hour = this.repair(date.getHours());//时
          let minute = this.repair(date.getMinutes());//分
          let second = this.repair(date.getSeconds());//秒

          //当前时间
          let curTime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
          let user = this.security.getUser();
          this.$refs.backorder.editRow.REVIEW_USERID = user.uid;
          this.$refs.backorder.editRow.REVIEW_TIME = curTime;

            this.$refs.allForm.editRow = this.$refs.backorder.editRow;
            //判断如果审核不通过，修改状态为 1：待接单  TODO 需要清空之前的自检、签到等信息？ 后要求改为待签到状态：3
            if(this.$refs.backorder.editRow.REVIEW_TYPE == '2'){
              this.$refs.allForm.editRow.SERVICE_STATE = '3';
            } else {//通过，状态为已返单：
              this.$refs.allForm.editRow.SERVICE_STATE = '8';
            }

            this.$refs.allForm.callableSave("YW_SERVICE_ORDER");
          break
        }
        default: {
          break
        }
      }
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('backOrder')
      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },
    repair(i) {
      if (i >= 0 && i <= 9) {
        return "0" + i;
      } else {
        return i;
      }
    }
  }
}
</script>
<style scoped>
  /* .core .layui-form {
    padding: 10px 20px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/workOrder/backOrde/backOrderform.vue